import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Button } from "PFComponents/button";
import { Tooltip } from "PFComponents/tooltip";
import { copyTextToClipboard } from "PFCore/helpers/copy_text_to_clipboard";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import React from "react";
import { useTranslation } from "react-i18next";

const GROWL_TTL = 2500;

const appendTimezone = (subscriptionUrl: string, tz: string): string => {
  const url = new URL(subscriptionUrl);
  url.searchParams.set("tz", tz);
  return url.toString();
};

export const CopyCalendarLinkButton = (): React.ReactElement | null => {
  const { t } = useTranslation("profiles");
  const { data: currentProfile } = useCurrentProfile();
  const { showGrowl } = useGrowlStoreActions();

  const calendarSubscriptionUrl = currentProfile?.availability?.calendarSubscriptionUrl;

  if (!calendarSubscriptionUrl) {
    return null;
  }

  const handleCopy = () => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const url = appendTimezone(calendarSubscriptionUrl, tz);

    copyTextToClipboard(url)
      .then(() =>
        showGrowl({
          message: t("show.parts.availability.copyCalendarLinkSuccess"),
          kind: "success",
          ttl: GROWL_TTL
        })
      )
      .catch(() =>
        showGrowl({
          message: t("show.parts.availability.copyCalendarLinkError"),
          kind: "error",
          ttl: GROWL_TTL
        })
      );
  };

  return (
    <Tooltip content={t("show.parts.availability.copyCalendarLinkTooltip")}>
      <Button
        kind="secondary"
        icon="link"
        title={t("show.parts.availability.copyCalendarLink")}
        onClick={handleCopy}
      />
    </Tooltip>
  );
};
